<template>
  <div>
    <nav-breadcrumb :menu="[{label: ' 他项权证列表'}]"/>
    <div class="xzpadd10 bg-purple of">
      <data-table
        :table-data="tableData"
        :columns="columns"
        :page.sync="page"
        :pageSize.sync="pageSize"
        :filters.sync="filters"
        :actions="actions"
      />
    </div>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import {xmlBuildQuery} from "../../filters/CommonActions";
  import Status2CN from "../../filters/Status2CN";
  import {removeItem} from "../../filters/CommonActions";
    export default {
        name: "InfoSupplyList",
      data(){
        return{
          columns:[
            {
              type: 'index'
            },
            {
              label: '导入时间',
              field: 'd__dealerName'
            },
            {
              label: '所属银行',
              field: 'd__dealerCode'
            },
            {
              label: '文件名称',
              field: 'dt__name'
            },
            {
              label: '文件大小',
              field: 'dt__name'
            },
            {
              label: '状态',
              field: 'd__disabled',
              formatter: function (r,c,v) {
                return Status2CN(v)
              }
            },
            {
              label: '操作',
              opts:[
                {
                  label: '下载',
                  class: 'el-icon-edit',
                  clickHandler: (index, row)=> {
                    this.$router.push(
                      {
                        path: 'edit',
                        query: {
                          dealerId: row.d__dealerId
                        }
                      }
                    )
                  }
                },
              ]
            }
          ],
          tableData: {
            count: 0,
            data: []
          },
          dealerTypeOptions:[],
          page: 1,
          pageSize: 20,
          actions: [
            {
              label: '新增',
              class: 'el-button--primary',
              clickHandler: ()=>{
                this.$router.push({
                  path: 'Add'
                })
              }
            },
          ],
          filters: {
            labelWidth: '150px',
            form: {
              dt__deviceType:'',
            },
            columns: [
              {
                label: '所属银行',
                component: 'el-input',
                field: 'd__dealerCode'
              },
              {
                label: '状态',
                component: 'el-select',
                field: 'dt__dealerTypeId',
                options: this.dealerTypeOptions,
              },
              {
                label: '导入日期',
                component: 'date-range-picker',
                field: 't__applicationDate',
                op: ['gteq', 'lteq'],
                span: 14
              },

            ],
            onSubmit:()=>{
              this.page = 1
              this.getData()
            }
          }
        }
      },
      mounted() {
        this.getData()
        this.getDealerType()
      },
      computed: {
        filterParams() {
          return {
            pageSize: this.pageSize,
            pageOffset: (this.page - 1) * this.pageSize,
          }
        }
      },
      watch: {
        filterParams: function (newVal) {
          this.getData()
        }
      },
      methods: {
        getData: function () {
          xhr.getDealerList(
            Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
            res=> {
              try {
                this.tableData = res.data
              }catch(e){

              }
            })

        },
        getDealerType: function () {
          xhr.getDealerType(
            Object.assign({}, {}, {}),
            res=> {
              try {
                this.filters.columns[2].options = res.data.data.map(item=>{
                  return {
                    label: item.dt__name,
                    value:item.dt__dealerTypeId,
                  }
                })
              }catch(e){

              }
            })

        },
        removeItem: function (index, row) {
          removeItem(
            xhr.deleteConfigDepartment,
            {
              'd.departmentId' : row.d__departmentId
            },
            res=>{
              try {
                if(res.data.status == 'success') {
                  this.getConfigDepartmentAsTree()
                  this.getConfigDepartmentList(this.selected.id)
                }
              }catch (e) {

              }
            }
          )
        },
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/InfoSupplyList.vue